var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block",class:{align: !_vm.marks}},[_c('el-slider',_vm._b({staticClass:"silder",style:(_vm.sliderStyle),attrs:{"range":"","show-stops":"","min":_vm.min,"max":_vm.max,"marks":_vm.marks,"format-tooltip":(val) => {
      return `${_vm.tooltip}：${val}`
    }},on:{"change":_vm.change},model:{value:(_vm.selfData),callback:function ($$v) {_vm.selfData=$$v},expression:"selfData"}},'el-slider',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }